// extracted by mini-css-extract-plugin
module.exports = {"cards":"Profile_cards__1lWlM"};